import * as THREE from "three";

function getExportSize2(group) {
    let box3 = new THREE.Box3();
    let volume = 0;
    if (group.isGroup) {
        for (let i = 0, len = group.children.length; i < len; i++) {
            let obj = group.children[i];
            let objSize = getExportSize2(obj);
            volume += objSize.volume;
            box3.expandByPoint(objSize.box3.min);
            box3.expandByPoint(objSize.box3.max);
        }
    } else if (group instanceof Array) {
        for (let i = 0, len = group.length; i < len; i++) {
            let obj = group[i];
            let objSize = getExportSize2(obj);
            volume += objSize.volume;
            box3.expandByPoint(objSize.box3.min);
            box3.expandByPoint(objSize.box3.max);
        }
    } else if (group.isMesh) {
        group.updateWorldMatrix(false, false);
        volume += volumeOfGeometry(group.geometry, group.matrixWorld);
        box3.expandByObject(group);
    }

    return {
        volume: volume,
        box3: box3
    }
}

export function bboxOfGroup(group) {
    let box3 = new THREE.Box3();
    for (let i = 0, len = group.children.length; i < len; i++) {
        let obj = group.children[i];
        obj.updateWorldMatrix(false, false);
        box3.expandByObject(obj);
    }
    return box3;
}

//三角形面积计算
function areaOfTriangle(p1, p2, p3){
    let v1 = new THREE.Vector3();
    let v2 = new THREE.Vector3();
    // 通过两个顶点坐标计算其中两条边构成的向量
    v1 = p1.clone().sub(p2);
    v2 = p1.clone().sub(p3);
  
    let v3 = new THREE.Vector3();
    // 三角形面积计算
    v3.crossVectors(v1,v2);
    let s = v3.length() / 2;
    return s;
}

export function surfaceOfGeometry(geometry, matrixWorld) {
    matrixWorld = matrixWorld || new THREE.Matrix4();
    // 声明一个变量表示几何体的表面积
    let area = 0.0;
    // 遍历一个几何体的全部三角形geometry.faces，所有三角形面积累积就是几何体的表面积
    // 对于不规则曲面，细分程度越高，面积计算精度越高
    
    if (geometry.index) {
        var positions = geometry.attributes.position;
        var indices = geometry.index;
        for (var i = 0; i < indices.count; i += 3) {
            var a = new THREE.Vector3().fromBufferAttribute(positions, indices.array[i]);
            var b = new THREE.Vector3().fromBufferAttribute(positions, indices.array[i + 1]);
            var c = new THREE.Vector3().fromBufferAttribute(positions, indices.array[i + 2]);
            a.applyMatrix4(matrixWorld);
            b.applyMatrix4(matrixWorld);
            c.applyMatrix4(matrixWorld);

            area += areaOfTriangle(a, b, c);
        }
    } else {
        var positions = geometry.attributes.position;
        for (var i = 0; i < positions.count; i += 3) {
            var a = new THREE.Vector3().fromBufferAttribute(positions, i);
            var b = new THREE.Vector3().fromBufferAttribute(positions, i + 1);
            var c = new THREE.Vector3().fromBufferAttribute(positions, i + 2);
            a.applyMatrix4(matrixWorld);
            b.applyMatrix4(matrixWorld);
            c.applyMatrix4(matrixWorld);

            area += areaOfTriangle(a, b, c);
        }
    }
    return area;
}

export function volumeOfGeometry(geometry, matrixWorld) {
    var volume = 0;
    matrixWorld = matrixWorld || new THREE.Matrix4();
    if (geometry.index) {
        var positions = geometry.attributes.position;
        var indices = geometry.index;
        for (var i = 0; i < indices.count; i += 3) {
            var a = new THREE.Vector3().fromBufferAttribute(positions, indices.array[i]);
            var b = new THREE.Vector3().fromBufferAttribute(positions, indices.array[i + 1]);
            var c = new THREE.Vector3().fromBufferAttribute(positions, indices.array[i + 2]);
            a.applyMatrix4(matrixWorld);
            b.applyMatrix4(matrixWorld);
            c.applyMatrix4(matrixWorld);

            volume += __signedVolumeOfTriangle(a, b, c);
        }
    } else {
        var positions = geometry.attributes.position;
        for (var i = 0; i < positions.count; i += 3) {
            var a = new THREE.Vector3().fromBufferAttribute(positions, i);
            var b = new THREE.Vector3().fromBufferAttribute(positions, i + 1);
            var c = new THREE.Vector3().fromBufferAttribute(positions, i + 2);
            a.applyMatrix4(matrixWorld);
            b.applyMatrix4(matrixWorld);
            c.applyMatrix4(matrixWorld);

            volume += __signedVolumeOfTriangle(a, b, c);
        }
    }
    return Math.abs(volume);
}


function __signedVolumeOfTriangle(p1, p2, p3) {
    var v321 = p3.x * p2.y * p1.z;
    var v231 = p2.x * p3.y * p1.z;
    var v312 = p3.x * p1.y * p2.z;
    var v132 = p1.x * p3.y * p2.z;
    var v213 = p2.x * p1.y * p3.z;
    var v123 = p1.x * p2.y * p3.z;
    var volume = (1.0 / 6.0) * (-v321 + v231 + v312 - v132 - v213 + v123);
    if (isNaN(volume)) {
        console.error("isNaN", p1, p2, p3);
    }
    return volume;
}



// WEBPACK FOOTER //
// ./src/3dapps/js/calcSize.js